<template>
  <div class="top">
    <div class="topBar">
      <div class="item">
        <span class="item_back" v-if="isBack" @click="$router.push('/')"></span>
      </div>
      <div class="item">{{ titleName }}</div>
      <div class="item"></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: ["titleName", "isBack"],
};
</script>

<style lang="less" scoped>
.top {
  padding-top: 25px;
  width: 100%;
  height: 50px;
  line-height: 50px;
  text-align: center;
  background-color: #fff;
  border-bottom: 1px solid #eeeeee;
  .topBar {
    width: 100%;
    display: flex;
    flex-direction: row;
    .item {
      text-align: center;
      width: 33.3%;
      font-weight: bold;
      .item_back {
        border-left: 2px solid black;
        border-bottom: 2px solid black;
        display: inline-block;
        // background-color: brown;
        width: 10px;
        height: 10px;
        transform: rotate(45deg);
      }
      &:nth-child(1) {
        font-size: 20px;
        text-align: left;
        padding-left: 20px;
      }
    }
  }
}
</style>